import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { dashboardApi } from "@/lib/dashboard";

const aud = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });

export function OverdueInvoicesWidget() {
  const q = useQuery({
    queryKey: ["dashboard", "invoices"],
    queryFn: () => dashboardApi.invoices(),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });

  return (
    <Card>
      <CardHeader><CardTitle>Overdue Invoices</CardTitle></CardHeader>
      <CardContent>
        {q.isLoading ? (
          <Skeleton className="h-9 w-28" />
        ) : q.isError || !q.data ? (
          <p className="text-sm text-muted-foreground">Couldn't load invoices.</p>
        ) : q.data.overdueCount === 0 ? (
          <p className="text-sm text-muted-foreground">No overdue invoices — nice.</p>
        ) : (
          <Link to="/invoices?status=Overdue" className="block hover:underline">
            <span className="text-3xl font-semibold text-destructive">{q.data.overdueCount}</span>{" "}
            <span className="text-sm text-muted-foreground">overdue</span>
            <div className="text-sm text-muted-foreground mt-1">
              {aud.format(q.data.totalOutstanding)} outstanding
            </div>
          </Link>
        )}
      </CardContent>
    </Card>
  );
}
